import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import type { useUserEntitlements as UseUserEntitlementsQuery } from './__generated__/useUserEntitlements';

export type UserEntitlement =
  | 'departmentLocationSelection'
  | 'lineManagerContent'
  | 'unmindHelp'
  | 'unmindTalk'
  | 'userManagement'
  | 'supersetAnalytics'
  | 'nova'
  | 'organisationHealthBenchmark'
  | 'bespokeHelpContent'
  | 'generalHelpContent'
  | 'explore'
  | 'moodTracker'
  | 'wellbeingTracker'
  | 'talkAiMatching'
  | 'eapCanBookAppointments'
  | 'novaVoice';

export const USER_ENTITLEMENTS_QUERY = gql`
  query useUserEntitlements {
    user {
      id
      entitlements {
        departmentLocationSelection
        lineManagerContent
        unmindHelp
        unmindTalk
        userManagement
        supersetAnalytics
        nova
        organisationHealthBenchmark
        bespokeHelpContent
        generalHelpContent
        explore
        moodTracker
        wellbeingTracker
        talkAiMatching
        eapCanBookAppointments
        novaVoice
      }
    }
  }
`;

/**
 * Hook to retrieve the current user's entitlements.
 */
export function useUserEntitlements() {
  const { data, loading, error } = useQuery<UseUserEntitlementsQuery>(
    USER_ENTITLEMENTS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const entitlements = data?.user?.entitlements;

  return {
    entitlements: {
      departmentLocationSelection:
        entitlements?.departmentLocationSelection ?? false,
      lineManagerContent: entitlements?.lineManagerContent ?? false,
      unmindHelp: entitlements?.unmindHelp ?? false,
      unmindTalk: entitlements?.unmindTalk ?? false,
      userManagement: entitlements?.userManagement ?? false,
      supersetAnalytics: entitlements?.supersetAnalytics ?? false,
      nova: entitlements?.nova ?? false,
      organisationHealthBenchmark:
        entitlements?.organisationHealthBenchmark ?? false,
      bespokeHelpContent: entitlements?.bespokeHelpContent ?? false,
      generalHelpContent: entitlements?.generalHelpContent ?? false,
      explore: entitlements?.explore ?? false,
      moodTracker: entitlements?.moodTracker ?? false,
      wellbeingTracker: entitlements?.wellbeingTracker ?? false,
      talkAiMatching: entitlements?.talkAiMatching ?? false,
      eapCanBookAppointments: entitlements?.eapCanBookAppointments ?? false,
      novaVoice: entitlements?.novaVoice ?? false,
    },
    loading,
    error,
  };
}

export default useUserEntitlements;
